// Tiny read-cache: stores the last successful GET response so key screens
// (dashboard, entries) remain viewable offline.
const PREFIX = "ct_cache_";

export function cacheSet(key, data) {
  try {
    localStorage.setItem(PREFIX + key, JSON.stringify({ t: Date.now(), data }));
  } catch {}
}

export function cacheGet(key) {
  try {
    const raw = localStorage.getItem(PREFIX + key);
    return raw ? JSON.parse(raw).data : null;
  } catch {
    return null;
  }
}
